import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Label,
  Spinner,
} from 'reactstrap';
import withRouter from '../../../../components/Common/withRouter';
import { withTranslation } from 'react-i18next';

import BreadCrumb from '../../../../components/Common/BreadCrumb';
import { deleteLetterHeadFile, getLetterHeadFile, uploadLetterHeadFile } from '../../../../slice/settings/thunk';
import config from '../../../../config';

const LetterHead = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const { letterhead } = useSelector((state) => state.Settings);

  useEffect(() => {
    dispatch(getLetterHeadFile());
  }, [dispatch]);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      console.log(URL.createObjectURL(e.target.files[0]));
      setSelectedFile(e.target.files[0]);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append('file', selectedFile);

    setLoading(true);
    await dispatch(uploadLetterHeadFile(formData));
    setLoading(false);
    setSelectedFile(null);
    // Reset file input
    document.getElementById('letterHeadInput').value = '';
  };

  const handleDelete = async () => {
    if (window.confirm(props.t('Are you sure you want to delete this letterhead?'))) {
      setLoading(true);
      await dispatch(deleteLetterHeadFile(letterhead));
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={props.t('Payroll')} breadcrumbItem={props.t('Letter Head')} />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">{props.t('Manage Letter Head')}</h4>
                  <Col>
                    <Col md="6">
                      <div className="mb-3">
                        <Label htmlFor="letterHeadInput" className="form-label">
                          {props.t('Upload New Letter Head')}
                        </Label>
                        <div className="input-group">
                          <Input
                            type="file"
                            className="form-control"
                            id="letterHeadInput"
                            accept="image/*"
                            onChange={handleFileChange}
                          />
                          <Button
                            color="primary"
                            onClick={handleUpload}
                            disabled={!selectedFile || loading}
                          >
                            {loading ? <Spinner size="sm" /> : props.t('Upload')}
                          </Button>
                        </div>
                        <p className="text-muted mt-2">
                          {props.t('Recommended size: 2480 x 3508 pixels (A4) or equivalent aspect ratio.')}
                        </p>
                      </div>
                    </Col>
                    <Col md="12">
                      <Label className="form-label">{props.t('Current Letter Head Preview')}</Label>
                      <div className="border rounded p-2 text-center" style={{ minHeight: '200px', backgroundColor: '#f8f9fa' }}>
                        {letterhead || selectedFile ? (
                          <div className="position-relative">
                            <img
                              src={letterhead ? `${config.api.API_URL}${letterhead}`: URL.createObjectURL(selectedFile)}
                              alt="Letter Head"
                              className="img-fluid img-thumbnail"
                              style={{ maxHeight: '400px' }}
                            />
                          {selectedFile && (
                            <i className="fa fa-trash me-1 position-absolute top-0 end-0" style={{cursor:'pointer',color:'red'}} onClick={()=>{setSelectedFile(null);document.getElementById('letterHeadInput').value = '';}}>
                            </i>
                          )}
                            {letterhead && (
                              <div className="mt-3">
                                <Button color="danger" outline onClick={handleDelete} disabled={loading}>
                                  <i className="bx bx-trash me-1"></i> {props.t('Delete')}
                                </Button>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="d-flex flex-column align-items-center justify-content-center h-100 py-5">
                            <i className="bx bx-image-alt display-4 text-muted"></i>
                            <p className="text-muted mt-2">{props.t('No letterhead uploaded yet')}</p>
                          </div>
                        )}
                      </div>
                    </Col>
                  </Col>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(withTranslation()(LetterHead));
